/**
 * Chunk warming, as a registry.
 *
 * The shell wants to warm the payment chunk while the cart is open, and the nav wants to warm
 * "My sales" on hover — but a feature may not import the route layer, and the route layer is
 * where the imports live. So the routes register loaders under a name and features ask for the
 * name. Dependencies keep pointing one way, and `shared/` still knows nothing about pages.
 */

const loaders = new Map<string, () => Promise<unknown>>();

export function registerPrefetch(name: string, loader: () => Promise<unknown>): void {
  loaders.set(name, loader);
}

/**
 * Fire-and-forget. A failed prefetch is not an error the user should ever see: the navigation
 * that follows will load the chunk again and report the failure properly if it persists.
 */
export function warm(name: string): void {
  void loaders.get(name)?.().catch(() => undefined);
}

/** A stable handler for `onPointerEnter` / `onTouchStart`, so it can sit in JSX without a closure. */
export const warmOn =
  (name: string) =>
  (): void => {
    warm(name);
  };
